import { makeStyles } from "@material-ui/core/styles";
import { calculateFontSize } from "../../CustomHooks/useThemeHook";

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    // whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  title: {
    // ...theme.typography.rockwell,
    fontSize: calculateFontSize(20, theme.palette.common.fontVariation),
    fontWeight: 700,
    margin: theme.spacing(0.4),
    color: theme.palette.common.headerFontColor,
  },
  branchesModalMobileContainer: {
    width: "78vw",
    // height: "47vh",
    height: "auto",
    // position: "fixed",
    // bottom: 0,
    // left: 0,
    // right: 0,
  },
  branchesModalContainer: {
    width: "450px",
    height: "auto",
  },
  branchModal: {
    padding: theme.spacing(2.5),
  },
  dropdownIcon: {
    marginLeft: "5px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  dropDownSection: {
    position: "absolute",
  },
  dropdownContainer: {
    position: "absolute",
    top: "65px",
    zIndex: 9999,
    maxHeight: "500px",
    height: "auto",
    overflowY: "scroll",
    overflowX: "hidden",
    backgroundColor: theme?.palette?.card?.cardColor || "#ffffff",
    color: theme?.palette?.card?.cardFontColor || "#000000",
    width: "50%",
    borderRadius: "12px",
    padding: "10px",
  },
  branchDiv: {
    borderBottom: "1px solid black",
    marginBottom: "10px",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      cursor: "pointer",
    },
  },
  list: {
    listStyle: "none",

    // borderRadius: "12px",
  },
  branchAddress: {
    color: theme?.palette?.card?.cardFontColor || "grey",
    fontWeight: 400,
    opacity: 0.8,
  },
  cartTitle: {
    fontSize: calculateFontSize(20, theme.palette.common.fontVariation),
    fontWeight: 700,
    margin: theme.spacing(0.4),
    color: theme.palette.common.themeFontColor,
  },
  location: {
    display: "flex",
    alignItems: "center",
    fontSize: calculateFontSize(12, theme.palette.common.fontVariation),
    fontWeight: 400,
    color: theme.palette.common.headerFontColor,

    whiteSpace: "nowrap", // Prevent line breaks
    display: "inline-block", // Ensure it's displayed in one line
  },
  locationSpl: {
    display: "flex",
    alignItems: "center",
    fontSize: calculateFontSize(12, theme.palette.common.fontVariation),
    fontWeight: 400,
    color: theme.palette.common.themeFontColor,
  },
  headerLogoDiv: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  headerLogo: {
    height: "45px",
    width: "auto",
  },
  iconBtn: {
    color: theme.palette.common.white,
  },
  blackColor: {
    // color: theme.palette.primary.main
    color: "#000",
  },
  noPadingIcon: {
    padding: theme.spacing(0),
  },
}));

export default useStyles;
